<ng-container *transloco="let t; prefix: 'group-management.interested-parties'">
  @if (rows().length > 0) {
    <ul class="m-0 flex list-none flex-col gap-3 p-0">
      @for (row of rows(); track row.id) {
        <li
          class="flex flex-col gap-2 rounded-md border border-primary-border bg-primary-bg p-4"
          data-testid="interested-party-card"
        >
          <div class="flex items-start justify-between gap-3">
            <p class="m-0 min-w-0 font-semibold break-words">{{ row.fullName }}</p>
            @if (row.converted) {
              <span class="shrink-0 rounded-full bg-secondary-bg px-2 py-0.5 text-xs font-semibold text-primary-text">
                {{ t('converted') }}
              </span>
            }
          </div>
          <p class="m-0 break-all text-secondary-text">{{ row.email }}</p>
          <p class="m-0 text-xs text-primary-text-light">
            {{ t('submitted') }}: {{ row.createdAt | date: 'MM/dd/yy' }}
          </p>
          @if (!row.converted) {
            <div class="flex flex-wrap gap-2">
              <app-button
                variant="secondary"
                size="sm"
                [loading]="convertingId() === row.id"
                [disabled]="busy()"
                [ariaLabel]="t('add-to-roster-aria', { name: row.fullName })"
                (clicked)="convert(row)"
              >
                {{ t('add-to-roster') }}
              </app-button>
              <app-button
                variant="outline"
                size="sm"
                [loading]="dismissingId() === row.id"
                [disabled]="busy()"
                [ariaLabel]="t('dismiss-aria', { name: row.fullName })"
                (clicked)="dismiss(row)"
              >
                {{ t('dismiss') }}
              </app-button>
            </div>
          }
        </li>
      }
    </ul>
  }
</ng-container>
